module.exports = __webpack_public_path__ + "img/easy-pumpkin-spice-cake.89c6ff8c.jpg";